'use strict';

module.exports = {
  global: 'global',
  pricingGroup: 'pricingGroup',
};
